import React, { useEffect, useRef, useState } from 'react'

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, CircularProgress } from '@material-ui/core'

import toastError from '../../errors/toastError'
import useQueues from '../../hooks/useQueues'

const QueueSelectModal = ({ open, onClose, onConfirm }) => {
  const [queues, setQueues] = useState([])
  const [selectedQueue, setSelectedQueue] = useState('')
  const [loading, setLoading] = useState(false)
  const { findAll } = useQueues()
  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (!open) return

    const loadQueues = async () => {
      setLoading(true)
      try {
        const data = await findAll()

        if (!isMounted.current) return

        setQueues(data)
        setSelectedQueue(data[0]?.id || '')
      } catch (err) {
        if (isMounted.current) {
          toastError(err)
          setQueues([])
          setSelectedQueue('')
        }
      } finally {
        if (isMounted.current) setLoading(false)
      }
    }

    loadQueues()
  }, [findAll, open])

  const handleConfirm = () => {
    if (!selectedQueue) return
    onConfirm(selectedQueue)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
      <DialogTitle>Selecione uma fila</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display='flex' justifyContent='center' py={2}>
            <CircularProgress />
          </Box>
        ) : (
          <FormControl fullWidth variant='outlined' margin='normal'>
            <InputLabel id='queue-select-label'>Fila</InputLabel>
            <Select labelId='queue-select-label' value={selectedQueue} onChange={e => setSelectedQueue(e.target.value)} label='Fila'>
              {queues.map(queue => (
                <MenuItem key={queue.id} value={queue.id}>
                  {queue.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleConfirm} color='primary' disabled={!selectedQueue || loading || queues.length === 0}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default QueueSelectModal
